import { render, staticRenderFns } from "./ConsentStatutoryBodyDialog.vue?vue&type=template&id=36ddad1b&"
import script from "./ConsentStatutoryBodyDialog.vue?vue&type=script&lang=js&"
export * from "./ConsentStatutoryBodyDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VRadio } from 'vuetify/lib/components/VRadioGroup';
import { VRadioGroup } from 'vuetify/lib/components/VRadioGroup';
installComponents(component, {VCardTitle,VRadio,VRadioGroup})
